import { useRef, useState, useCallback } from "react";
import { ChevronsLeftRight } from "lucide-react";

export const BeforeAfter = ({ before, after, beforeLabel = "AVANT", afterLabel = "APRÈS" }) => {
  const ref = useRef(null);
  const [pos, setPos] = useState(50);

  const update = useCallback((clientX) => {
    if (!ref.current) return;
    const rect = ref.current.getBoundingClientRect();
    setPos(Math.min(96, Math.max(4, ((clientX - rect.left) / rect.width) * 100)));
  }, []);

  const onPointerDown = (e) => {
    update(e.clientX);
    const move = (ev) => update(ev.clientX);
    const up = () => {
      window.removeEventListener("pointermove", move);
      window.removeEventListener("pointerup", up);
    };
    window.addEventListener("pointermove", move);
    window.addEventListener("pointerup", up);
  };

  return (
    <div
      ref={ref}
      data-testid="before-after-slider"
      onPointerDown={onPointerDown}
      className="relative aspect-[16/10] w-full cursor-ew-resize select-none overflow-hidden rounded-2xl border border-sky-500/15 shadow-2xl shadow-sky-950/50"
    >
      <img src={after} alt={afterLabel} draggable={false} className="absolute inset-0 h-full w-full object-cover" />
      <div className="absolute inset-0" style={{ clipPath: `inset(0 ${100 - pos}% 0 0)` }}>
        <img src={before} alt={beforeLabel} draggable={false} className="absolute inset-0 h-full w-full object-cover" />
      </div>

      <div
        className="absolute top-0 bottom-0 w-[2px] bg-sky-400 shadow-[0_0_24px_rgba(56,189,248,0.9)]"
        style={{ left: `${pos}%` }}
      >
        <div className="absolute top-1/2 flex h-11 w-11 -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full bg-sky-400 text-slate-950 shadow-lg shadow-sky-500/40">
          <ChevronsLeftRight size={18} />
        </div>
      </div>

      <span className="absolute top-4 left-4 rounded-full bg-slate-950/70 px-3.5 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-red-300 backdrop-blur">
        {beforeLabel}
      </span>
      <span className="absolute top-4 right-4 rounded-full bg-slate-950/70 px-3.5 py-1.5 text-xs font-bold uppercase tracking-[0.2em] text-sky-300 backdrop-blur">
        {afterLabel}
      </span>
    </div>
  );
};
